import React, { useState } from "react";
import SelectDropdown from "../../UI/SelectDropdown";
import { withTranslation } from "react-i18next";

 
const Question = ({ question, onAnswerChange, t }) => {
  const { id, fieldType, prompt, options, termsAndConditions, config } = question;
  const [value, setValue] = useState(
    fieldType === "multiple_select" ? [] : fieldType === "terms_and_conditions" ? false : ""
  );
  const [showList, setShowList] = useState(false);

  const handleInputChange = (e) => {
    setValue(e.target.value);
    onAnswerChange({
      questionId: id,
      answer: [{ value: e.target.value, key: null }]
    });
  };

  const handleSingleSelectChange = (obj) => {
    const selected = options.find((opt) => opt.key === obj.key);
    setValue(selected.key ? selected.key : "");
    onAnswerChange({
      questionId: id,
      answer: selected ? [{ key: selected.key, value: selected.value }] : []
    });
  };

  const handleMultiSelectChange = (e) => {
    const selectedValues = Array.from(e.target.selectedOptions).map((opt) => {
      return { key: opt.value, value: opt.label };
    });
    setValue(selectedValues.map((s) => s.key));
    onAnswerChange({
      questionId: id,
      answer: selectedValues
    });
  };

  const handleCheckboxChange = (e, option) => {
    let updatedValues;
    if (e.target.checked) {
      updatedValues = [...value, option.key];
    } else {
      updatedValues = value.filter((k) => k !== option.key);
    }
    setValue(updatedValues);
    onAnswerChange({
      questionId: id,
      answer: options
        .filter((opt) => updatedValues.includes(opt.key))
        .map((opt) => ({ key: opt.key, value: opt.value }))
    });
  };

  const handleTermsChange = (e) => {
    const checked = e.target.checked;
    setValue(checked);
    onAnswerChange({
      questionId: id,
      answer: [{ value: checked, key: null }]
    });
  };

  // Render per type
  switch (fieldType) {
    case "input":
    case "email":
    case "phone":
      return (<>
      {/* temp changes */}
      { <div>
         <div>{prompt}</div>
         <input
           type="text"
           value={value}
           disabled={config.disabled}
           onChange={handleInputChange}
         />
       </div>
       
      }
      </>
      );

    case "textarea":
      return (
        <div >
          <div>{prompt}</div>
          <textarea value={value} onChange={handleInputChange} />
        </div>
      );

    case "single_select":
      return ( 
      <div className="select-wrapper">
          <label>{prompt}</label>
          <SelectDropdown
            selectKey="obj.value"
            selectedItem={value ? (options.find(op => op.key==value)).value : ""}
            listData={options}
            showList={showList}
            setShowList={() => {
              setShowList(p=>!p);
            }}
            setSelectedItem={(obj)=>{
              setShowList(p=>!p);
              handleSingleSelectChange(obj)
            }
            }
          />
      </div>
      );

    case "multiple_select":
      return (
        <div style={{ 
          }} >
          <div>{prompt}</div>
          {options && options.map((opt) => (
            <div key={opt.key}>
              <div style={{ gap: "4px",     display: "flex"}} >
                <input
                  type="checkbox"
                  value={opt.key}
                  checked={value.includes(opt.key)}
                  onChange={(e) => handleCheckboxChange(e, opt)}
                />
                {opt.value}
              </div>
            </div>
          ))}
        </div>
      );

    case "terms_and_conditions":
      return (
        <div>
          <div style={{ gap: "4px",     display: "flex"}} >
            <input type="checkbox" checked={value} onChange={handleTermsChange} />
            {t("way_activity.question_component.terms_prefix")}{" "}
            <a href={termsAndConditions.mediaURL ?  termsAndConditions.mediaURL :""} target="_blank" rel="noopener noreferrer">
              {termsAndConditions.label || t("way_activity.question_component.terms_link_fallback")}
            </a>
          </div>
        </div>
      );

    default:
      return null;
  }
};

// const QuestionForm = ({ questions }) => {
//   const [answers, setAnswers] = useState([]);

//   const handleAnswerChange = (answerObj) => {
//     setAnswers((prev) => {
//       const existingIndex = prev.findIndex((a) => a.questionId === answerObj.questionId);
//       if (existingIndex >= 0) {
//         const updated = [...prev];
//         updated[existingIndex] = answerObj;
//         return updated;
//       }
//       return [...prev, answerObj];
//     });
//   };

//   const handleSubmit = () => {
//     console.log("Final Answer Payload:", answers);
//     // send `answers` to your API
//   };

//   return (
//     <div>
//       {questions.map((q) => (
//         <Question key={q.id} question={q} onAnswerChange={handleAnswerChange} />
//       ))}
//       <button onClick={handleSubmit}>Submit</button>
//     </div>
//   );
// };

export default withTranslation("translations")(Question);

